import type { User } from "../../../types/interfaces";

export interface LoginResponse {
	uid: string;
	access_token: string;
	refresh_token: string;
	expires_in: number;
	user: User;
}

export interface LoginPayload {
	email: string;
	password: string;
}

export enum Tool {
	EXACT = "EX-ACT",
	B_INTACT = "B-INTACT",
}

export interface AuthState {
	accessToken: string | null;
	refreshToken: string | null;
	user: User | null;
}

export interface RegisterPayload {
	password: string;
	first_name?: string;
	last_name?: string;
	email?: string;
	country?: number | null;
	organization?: string;
	is_opted_out_of_emails?: boolean;
	// affiliated_institution: string
	// institution_country: string
	// job_title: string
}

export interface RegisterResponse {
	id: number;
	password: string;
	first_name: string;
	last_name: string;
	// email: string, required!
}

export interface PasswordResetPayload {
	email: string
}

export interface UpdatePasswordPayload {
	old_password: string,
	new_password: string,
	userId: number
}

/** Form-level extension of RegisterPayload with consent checkboxes. */
export type RegisterFormType = RegisterPayload & {
	isAgreeToTerms: boolean;
	isAgreeToGDPR: boolean;
	isAgreeToEmailUpdates: boolean;
};

/**
 * Default values for the registration form. Lives in the feature layer (not in
 * `src/pages`) so `registerSlice` can consume it without an app→pages import.
 * See docs/adr/0001-feature-vs-page-layering.md.
 */
export const registerInitialValues: RegisterFormType = {
	password: "",
	first_name: "",
	last_name: "",
	email: "",
	organization: "",
	country: null,
	isAgreeToEmailUpdates: true,
	isAgreeToGDPR: false,
	isAgreeToTerms: false,
};